import Vue from 'vue';
import layer from 'vue-layer';

import 'normalize.css/normalize.css';// A modern alternative to CSS resets

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/zh-CN'; // lang i18n
import VueContextMenu from 'vue-contextmenu';

import '@/styles/index.scss'; // global css

import App from './App';
import router from './router';
import store from './store';
import '../src/utils/dialogDrag.js';

import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';
import XEUtils from 'xe-utils';
import VXEUtils from 'vxe-utils';

import '@/icons'; // icon
import '@/permission'; // permission control
import '@/assets/public/css/iconfont/iconfont.css';
import '@/assets/public/css/iconfont/iconfont.js';
import '@/assets/public/css/comIconfont/iconfont/iconfont.css';
import '@/assets/public/css/comIconfont/iconfont/iconfont.js';
import '@/assets/public/css/otherIcon/iconfont.css';
import '@/assets/public/css/otherIcon/iconfont.js';

// 请假条表单和详情
import FrmLeaveReqAdd from '@/views/forms/userDefine/frmLeaveReq/add';
import FrmLeaveReqDetail from '@/views/forms/userDefine/frmLeaveReq/detail';
// 抽屉组件
import drawerViews from '@/components/DrawerViews';
import productionplandetail from '@/views/forms/userDefine/productionplans/detail';

// import '../public/ueditor/ueditor.config.js'
// import '../public/ueditor/ueditor.all.min.js'
// import '../public/ueditor/lang/zh-cn/zh-cn.js'
// import '../public/ueditor/ueditor.parse.min.js'
// import '../public/ueditor/formdesign/leipi.formdesign.v4.js'

// import signalr from './utils/signalR'
// Vue.use(signalr)

Vue.component('drawerViews', drawerViews);
Vue.use(VXETable);
Vue.use(ElementUI, { locale });
import '../theme/index.css';

Vue.use(VueContextMenu);

// mounts 可以设置['cookie', 'browse', 'locat']
Vue.use(VXEUtils, XEUtils, { mounts: ['cookie'] });

// this.$utils

Vue.config.productionTip = false;
Vue.prototype.$layer = layer(Vue, {
  msgtime: 3
});
Vue.component('FrmLeaveReqAdd', FrmLeaveReqAdd);
Vue.component('FrmLeaveReqDetail', FrmLeaveReqDetail);
Vue.component('ProductionPlanDetail', productionplandetail);

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});
